import { registerPlugin } from '@capacitor/core';
import type { DevereCapacitorSessionStorageProtocol } from './definitions';


const SessionStorage = registerPlugin<DevereCapacitorSessionStorageProtocol>('DevereCapacitorSessionStorage', {
    web: () => import('./plugin').then(m => new m.SessionStorage()),
});

export * from './definitions';
export { SessionStorage };